export enum ChargeDisplayStatusEnum {
  PENDING = 'PENDING',
  UNPAID = 'UNPAID',
  OVERDUE = 'OVERDUE',
  PAID = 'PAID',
  VOIDED = 'VOIDED',
}
